import { useEffect, useState, useRef, useCallback } from "react";
import { limit, query, onSnapshot, doc, setDoc, serverTimestamp, orderBy, updateDoc } from "firebase/firestore";
import { db, firebase } from "../../utils/init-firebase";
import {
    Box,
    Heading,
    IconButton,
    Divider,
    useColorModeValue,
    Progress,
    Flex,
    Switch,
    FormLabel} from "@chakra-ui/react";
import { FormControl } from "@chakra-ui/react";
import { getDefaultKeyBinding } from "draft-js";
import { AiOutlineSend } from "react-icons/ai";
import { FiPlus, FiUpload } from "react-icons/fi";
import { useAuth } from "../../contexts/AuthContext";
import MessageList from "./MessageList";
import { EditorState, convertToRaw} from "draft-js";
import ChatInput from "../ChatInput/ChatInput";
import editorStyles from '../ChatInput/SimpleMentionEditor.module.css';
import { useLocation } from "react-router-dom";
import { MdBlock } from "react-icons/md";
import AddVideoLinkPopover from "../GroupChat/AddVideoLinkPopover";

// Set parentID to 'n/a' if using in a collection
// Set parentID to the parent doc id if using in a subcollection
// Heading defaults to 'CHAT' if null
export default function GroupChat( { 
        fillContainer,
        collectionRef, 
        collectionName, 
        parentID, 
        heading, 
        width, 
        isNotes, 
        isNotesForReview, 
        setNotesForReviewCount, 
        setShowNotesForReviewToast, 
        restrictPosting, 
        fullPageChat, 
        fullPageNotes, 
        parentDocContent, 
        isDashboard, 
        referencedLoan,
        maxMsgs 
    }) {
    const editorClass = useColorModeValue(editorStyles.editor, editorStyles.darkeditor)
    const editorClassDisabled = useColorModeValue(editorStyles.editorDisabled, editorStyles.darkeditorDisabled)
    const [editorState, setEditorState] = useState(
        () => EditorState.createEmpty(),
    )
    const { currentUser, loading, SuperAdmin, notifications } = useAuth()

    const [messageList, setMessageList] = useState([])
    const [loadingMessages, setLoadingMessages] = useState(true)
    const [disabled, setDisabled] = useState(false)
    const [message, setMessage] = useState('')
    const location = useLocation()

    const [notifyPeople, setNotifyPeople] = useState(true)

    const inputRef = useRef();
    const formRef = useRef()

    const [files, setFiles] = useState([])
    const [uploadedFiles, setUploadedFiles] = useState([])

    const [uploadProg, setUploadProg] = useState()
    const [uploading, setUploading] = useState(false)

    const uploadFiles = useCallback(()=>{
        if(files.length > 0)
        {
            setUploading(true)                    
            const theseFiles = files;
            setFiles([])
            var promises = []
            for (let i = 0; i < theseFiles.length; i++) {         
                    const storageRef = firebase.storage().ref();
                    const file = theseFiles[i];
 
                    promises.push(storageRef
                    .child(`${collectionName}/${currentUser.displayName}/${parentID}/${file.name}`)
                    .put(file).then( async (snapshot) => {
                       snapshot.ref.getDownloadURL().then( async (url) => {
                            setUploadedFiles(prevState => [...prevState, {url: url, name: file.name}])
                           // setFileURLs(prevState => [...prevState, url]);
                            //setFileNames(prevState => [...prevState, file.name]);
                                    return
                                }
                            )
                        })
                    )
            }
            Promise.all(promises)
            .then( async () => {
                    setUploading(false)
                }
            )
            .catch(err => console.log(err.code));
            
        }
    },[files])

    function removeAttachment(i){
        uploadedFiles.splice(i, 1)
        setFiles([])

    }
    const onFileChange = (e) => {
        setFiles(e.target.files)
    }

    const handleFileDrop = (files) => {
        setFiles(files)
    }

    useEffect(()=> {
        uploadFiles();
      }, [files])


    const handleMsgChange = (e) => {

        setMessage(e.value)
    }

    function renderSuggestion(entry, search, highlightedDisplay, index, focused) {
        // Modify the suggestion dropdown by returning valid JSX
        return (
          <>
            <span>{entry.display}</span>
          </>
        );
      }

      function getUniqueListBy(arr, key) {
        return [...new Map(arr.map(item => [item[key], item])).values()]
        }

      function onAdd(id, display) {
        // Do something here
      }

      function handleSetNotifyPeople (e) {
          setNotifyPeople(e.target.checked)
      }

    function handleKeyBind(e){
        if (e.keyCode === 13 && !e.shiftKey && !(e.metaKey || e.ctrlKey)) {
          return 'send-message';
        } else if (e.keyCode === 13 && e.shiftKey) {
            return 'split-block';
        }
        return getDefaultKeyBinding(e);
      }
    
      function handleKeyCommand (command) {
        if (command === 'send-message') {
          handleSubmit()
          return 'handled'
        }
        return 'not-handled';
      }

    const handleSubmit = async () => {
        const contentState = editorState.getCurrentContent()
        let message = contentState.getPlainText('\u0001')
        const mentions = convertToRaw(contentState).entityMap
        await addMessage(message, mentions)
    }
    async function addMessage(message, mentions){
        try{
            const newMsgRef = doc(collectionRef)
            let mentioned = []
            let mentionedObj = []
            Object.entries(mentions).forEach(function([key, mentionData]) {
                let thisMention = mentionData?.data?.mention
                if(thisMention){
                    message = message.replace(thisMention.name, "")
                }
            })
            Object.entries(mentions).forEach( async function([key, mentionData]) {
                let thisMention = mentionData?.data?.mention
                if(thisMention && 
                   thisMention.name?.trim() && 
                   thisMention.email?.trim() && 
                   thisMention.uid?.trim() && 
                   thisMention.avatar?.trim()) {
                    let user = {
                        Name: thisMention.name.trim(),
                        Email: thisMention.email.trim(),
                        photoURL: thisMention.avatar.trim(),
                        uid: thisMention.uid.trim(),
                    }
                    
                    mentioned.push(thisMention.name.trim())
                    mentionedObj.push({...user, ...{isMention: true}})
                } else {
                    console.warn('Invalid or empty mention data:', thisMention)
                }
            
/*              const notifRef = doc(collection(db, "users", thisMention.uid, 'Notifications'))
                await setDoc(notifRef, {
                    message: message,
                    user: {
                        uid: currentUser.uid,
                        displayName: currentUser.displayName,
                        photoURL: currentUser.photoURL,
                        email: currentUser.email,
                    },
                    loanID: parentID,
                    messageID: newMsgRef.id,
                    timestamp: serverTimestamp(),
                    id: notifRef.id,
                    read: false
                  }) */

            })
            if((collectionName == 'Marketing Requests' || collectionName == 'Escalations' ) && notifyPeople && parentDocContent){
                if(parentDocContent['Owner'] && 
                   parentDocContent['Owner'].Name?.trim() && 
                   parentDocContent['Owner'].Email?.trim() && 
                   parentDocContent['Owner'].uid?.trim()) {
                    let owner = {
                        ...parentDocContent['Owner'],
                        Name: parentDocContent['Owner'].Name.trim(),
                        Email: parentDocContent['Owner'].Email.trim(),
                        uid: parentDocContent['Owner'].uid.trim(),
                        isMention: false
                    }
                    mentionedObj.push(owner)
                }
                if(parentDocContent['Assignees']){
                    parentDocContent['Assignees'].forEach((assignee) => {
                        if(assignee.Name?.trim() && 
                           assignee.Email?.trim() && 
                           assignee.uid?.trim()) {
                            mentionedObj.push({
                                ...assignee,
                                Name: assignee.Name.trim(),
                                Email: assignee.Email.trim(),
                                uid: assignee.uid.trim(),
                                isMention: false
                            })
                        }
                    })
                }
            }

            // include loan team on notifications if settings say so & notify switch is on
            if(collectionName == 'Escalations' && notifyPeople && parentDocContent && referencedLoan){
                const addTeamMember = (member, role) => {
                    if(member && 
                       member.Name?.trim() && 
                       member.Email?.trim() && 
                       member.uid?.trim()) {
                        mentionedObj.push({
                            ...member,
                            Name: member.Name.trim(),
                            Email: member.Email.trim(),
                            uid: member.uid.trim(),
                            isMention: false
                        })
                    }
                }

                if(parentDocContent.Settings && parentDocContent.Settings['Notify LO'] && referencedLoan['Loan Officer']){
                    addTeamMember(referencedLoan['Loan Officer'])
                }
                if(parentDocContent.Settings && parentDocContent.Settings['Notify LOA'] && referencedLoan['LOA']){
                    addTeamMember(referencedLoan['LOA'])
                }
                if(parentDocContent.Settings && parentDocContent.Settings['Notify LC'] && referencedLoan['LC']){
                    addTeamMember(referencedLoan['LC'])
                }
                if(parentDocContent.Settings && parentDocContent.Settings['Notify CSC'] && referencedLoan['CSC']){
                    addTeamMember(referencedLoan['CSC'])
                }
                if(parentDocContent.Settings && parentDocContent.Settings['Notify TC'] && referencedLoan['TC']){
                    addTeamMember(referencedLoan['TC'])
                }
            }

            // include loan team if notify switch is on
            if(collectionName == 'Clients' && notifyPeople && parentDocContent){
                const addTeamMember = (member) => {
                    if(member && 
                       member.Name?.trim() && 
                       member.Email?.trim() && 
                       member.uid?.trim()) {
                        mentionedObj.push({
                            ...member,
                            Name: member.Name.trim(),
                            Email: member.Email.trim(),
                            uid: member.uid.trim(),
                            isMention: false
                        })
                    }
                }

                if(parentDocContent['Loan Officer']){
                    addTeamMember(parentDocContent['Loan Officer'])
                }
                if(parentDocContent['LOA']){
                    addTeamMember(parentDocContent['LOA'])
                }
                if(parentDocContent['LC']){
                    addTeamMember(parentDocContent['LC'])
                }
                if(parentDocContent['CSC']){
                    addTeamMember(parentDocContent['CSC'])
                }
                if(parentDocContent['TC']){
                    addTeamMember(parentDocContent['TC'])
                }
            }

            // Add cleanup function for mentionedObj
            const cleanMentionedObj = (arr) => {
                // Remove duplicates based on uid
                const uniqueArr = arr.filter((obj, index, self) =>
                    index === self.findIndex((t) => t.uid === obj.uid)
                );
                
                // Remove objects with empty values
                return uniqueArr.filter(obj => 
                    obj.Name?.trim() && 
                    obj.Email?.trim() && 
                    obj.uid?.trim()
                );
            };

            // Clean up mentionedObj before saving
            const cleanedMentionedObj = cleanMentionedObj(mentionedObj);
            console.log('Cleaned mentionedObj:', cleanedMentionedObj);

            await setDoc(newMsgRef, {
                message: message,
                parentID: parentID,
                parentSnapshot: parentDocContent ? parentDocContent : null, 
                id: newMsgRef.id,
                user: {
                    uid: currentUser.uid,
                    displayName: currentUser.displayName,
                    photoURL: currentUser.photoURL,
                    email: currentUser.email,
                },
                timestamp: serverTimestamp(),
                mentioned: mentioned,
                mentionedObj: cleanedMentionedObj,
                notifyPeople: notifyPeople,
                path: location.pathname,
                Files: uploadedFiles
            })
            
            setEditorState(EditorState.createEmpty())
            setUploadedFiles([])
        }
        catch(err){
            console.log(err)
        }
    }

    // Keyed on the collection path (a stable string) rather than the ref object:
    // callers often build collectionRef inline, giving it a new identity every
    // render. The effect must also be synchronous — an async effect returns a
    // Promise, so React never receives the unsubscribe and the listener leaks.
    useEffect(() => {
        const q = query(collectionRef, orderBy("timestamp", 'desc'), limit(maxMsgs ?  maxMsgs : 100));
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const messages = []
            querySnapshot.forEach((msg) => {
                messages.push(msg.data())
            })
            setMessageList(messages)

        });
        setLoadingMessages(false)

        return () => {
            unsubscribe();
        };  

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [collectionRef?.path, maxMsgs])

     useEffect(() => {
        const markNotificationsRead = async () => {
            try{
                if(notifications && messageList){
                    for(const msg of messageList ){
                        notifications.forEach( async (notif) => {
                            if(notif.messageID == msg.id){
                                const notificationRef = doc(db, 'users', currentUser.uid, 'Notifications', notif.id)
                                await updateDoc(notificationRef, {
                                    read: serverTimestamp()
                                })
                            }
                        });
                    }
                }
            }
            catch(err){
                console.log(err)
            }
        }
        markNotificationsRead()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [messageList]) 

    return (
        <>
            <Box 
                width={width ? width 
                    :
                    {    
                        base: '100%',
                        xl: '65%'
                    }}    
                height={fullPageChat ? '100%' : undefined}
                borderWidth={!isDashboard && '1px'} 
                borderTopRadius={!fullPageChat && !isNotes && !isDashboard && 'lg'}
                borderRightRadius={!fullPageChat && !isNotes && !isDashboard && 'lg'}
                position='relative'
                display={fullPageChat ? 'flex' : 'block'}
                flexDirection={fullPageChat ? 'column' : undefined}
                overflow={fullPageChat ? 'hidden' : undefined}
            >
      

            <Flex justifyContent={'space-between'}>
                <Box>
                {!isNotes && <Heading p={2} size='sm'>{heading ? heading : 'CHAT'}</Heading>}
                </Box>
                {(collectionName == 'Marketing Requests' || collectionName == 'Clients' || collectionName == 'Escalations') &&
                    <Box p={2} >
                    <FormControl justifySelf={'flex-end'} display='flex' alignItems='center'>
                        <FormLabel fontSize={'sm'} htmlFor='notify-people' mb='0'>
                            Notify People on&nbsp;
                                {collectionName == 'Marketing Requests' ? 'Request' : 
                                    collectionName == 'Escalations' ? 'Escalation' : 'File'}
                        </FormLabel>
                        <Switch id='notify-people' defaultChecked={notifyPeople} onChange={(e) => handleSetNotifyPeople(e)}/>
                    </FormControl>
                    </Box>
                }
            </Flex>
            <Divider/>

            <Box 
                flex={fullPageChat ? '1' : undefined}
                overflow={fullPageChat ? 'hidden' : undefined}
                display={fullPageChat ? 'flex' : 'block'}
                flexDirection={fullPageChat ? 'column' : undefined}
            >
                <MessageList 
                    marketingChat={collectionName == 'Marketing Requests' && true} 
                    messageList={messageList} 
                    isNotes={isNotes} 
                    isDashboard={isDashboard} 
                    fullPageNotes={fullPageNotes} 
                    fullPageChat={fullPageChat}
                    collectionRef={collectionRef} 
                    collectionName={collectionName}
                />
            </Box>
               

                 
                  {restrictPosting && !SuperAdmin ? 
                        <></>
                        // <div className={editorClassDisabled}>
                        //     <Text textColor={'gray.500'} as='em' >You do not have permission to post in this channel</Text>
                        // </div>
                    :
                    <Box 
                        flexShrink={0}
                        position={fullPageChat ? 'relative' : undefined}
                    >
                        <div className={editorClass}>
                            {uploading && <Progress size='xs' isIndeterminate />}

                            <ChatInput 
                                isDashboard={isDashboard}
                                editorState={editorState}
                                setEditorState={setEditorState}
                                handleKeyBind={handleKeyBind}
                                handleKeyCommand={handleKeyCommand}
                                fullPageChat={fullPageChat}
                                uploadedFiles={uploadedFiles}
                                removeAttachment={removeAttachment}
                                handleDropFiles={handleFileDrop}
                            /> 
                        </div>
                        <IconButton 
                        onClick={handleSubmit}
                        disabled={(!editorState.getCurrentContent().hasText() && !uploadedFiles.length > 0) || uploading}
                        variant='solid'
                        position='absolute'
                        colorScheme={'green'}
                        opacity={'85%'}
                        bottom={2}
                        right={2}
                        border='none'
                        isRound
                        aria-label='Delete message'
                        size='md'
                        isLoading={uploading}
                        spinner={<MdBlock/>}
                        icon={isNotes || fullPageNotes ? 
                            <FiPlus/>
                            :
                            <AiOutlineSend/>
                        }
                        />
                        {SuperAdmin && isDashboard &&
                            <AddVideoLinkPopover 
                                uploading={uploading}
                                collectionRef={collectionRef}
                            />
                    
                        }
                        <input type='file'
                            onChange={onFileChange}
                            multiple='multiple'
                            name={'Upload Files'}
                            ref={inputRef}
                            style={{display: 'none'}} />
                        <IconButton
                            icon={<FiUpload/>}
                            position='absolute'        
                            isLoading={uploading}
                            disabled={uploading}
                            bottom={2}
                            right={12}
                            onClick={() => inputRef.current.click()}
                            variant='ghost'
                        />
                    </Box>
                    } 

                  
         </Box>
         </>
    );
}
